import type { LanguageCode } from "config/languages";

export const getLocaleFromUrl = (url: string) => url?.split("/")[1] as LanguageCode;
